import { createSelector } from "reselect"

import {
  isPagesPlatformPage,
  isPagesPlatformContentPage,
  isPagesInvitePage,
} from "common/services/url/recognitionHelpers"

// simple selector
const pageNamesPathSelector = state => state.page.get("namesPath")

export const isPagesPlatformPageSelector = createSelector(
  pageNamesPathSelector,
  isPagesPlatformPage,
)

export const isPagesPlatformContentPageSelector = createSelector(
  pageNamesPathSelector,
  isPagesPlatformContentPage,
)

export const isPagesInvitePageSelector = createSelector(
  pageNamesPathSelector,
  isPagesInvitePage,
)
